import { getAge, GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic'

export const nationwidechildrens: GetCustomerCopyFunc = () => {
  return {
    shouldUseCustomChildCare: (childDOB: string) => getAge({ date: childDOB }) < 6,
  }
}
